export const QUESTION_CONTENT_TYPE =
	'ac:com.atlassian.confluence.plugins.confluence-questions:question';
export const ANSWER_CONTENT_TYPE =
	'ac:com.atlassian.confluence.plugins.confluence-questions:answer';
export const VOTES_PROPERTY_KEY = 'atl_cq_votes';
export const ACCEPTED_ANSWER_PROPERTY_KEY = 'atl_cq_accepted_answer';
